import { render, staticRenderFns } from "./NameComp.vue?vue&type=template&id=01d1d740&scoped=true&"
import script from "./NameComp.vue?vue&type=script&lang=ts&"
export * from "./NameComp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d1d740",
  null
  
)

export default component.exports